<template>
  <label class="box-ajuda-st" :class="`${classe}-icon`" v-if="titleMessage">
    <font-awesome-icon
      v-b-tooltip.hover.top
      :title="titleMessage"
      icon="info-circle"
      class="info-circle"
    />
    <p class="mensagem-impressao">{{ titleMessage }}</p>
  </label>
</template>

<script>
export default {
  name: "AjudaIcon",
  props: {
    option: String,
    classe: String
  },
  data() {
    return {
      messages: {
        antecipacao: [
          "Cenário passível de antecipação tributária, sendo necessário analisar se a mercadoria e a operação indicada atendem as disposições da legislação vigente. Quando não atendidas as condições previstas na legislação, não deverá ser considerada a antecipação tributária.",
          "Operação sujeita a antecipação tributária.",
          "Operação não sujeita a antecipação tributária nesta operação."
        ],
        icms_st: [
          "Item passível de sujeição à substituição tributária, sendo necessário analisar se a NCM e a descrição do produto comercializado são as mesmas constantes no Convênio ICMS nº 142/2018. Na hipótese da descrição do item não reproduzir a correspondente descrição do código ou posição utilizada na NCM/SH, não deverá ser considerada a sujeição à substituição tributária.",
          "Item sujeito a substituição tributária nesta operação.",
          "Item não sujeito a substituição tributária nesta operação."
        ],
        carga_liquida: [
          "Item passível de incidência da cobrança de ICMS por Carga Líquida, sendo necessário analisar se o tratamento tributário indicado nesta seção atende a legislação do segmento selecionado. Na hipótese de o item não corresponder o tratamento tributário indicado nesta legislação, não deverá ser considerada a sujeição à Carga Líquida para este Estado.",
          "Item sujeito a incidência da Carga Líquida nesta operação.",
          "Item não sujeito a incidência da Carga Líquida nesta operação."
        ]
      }
    };
  },
  computed: {
    titleMessage: function() {
      let messages = this.messages[this.classe];

      if (!messages) {
        return false;
      }

      if (this.option == "DEPENDE") return messages[0];
      if (this.option == "SIM") return messages[1];
      if (this.option == "NÃO") return messages[2];
      return false;
    }
  }
};
</script>

<style lang="scss">
.box-ajuda-st {
  // margin-top: -1px;
  // margin-left: 5px;
  // margin-bottom: -1px;
  // float: right;
  display: flex;

  .info-circle {
    background: none !important;

    &.svg-inline--fa {
      width: 21px !important;
      height: 21px !important;
    }
  }

  &.icms_st-icon .info-circle,
  &.carga_liquida-icon .info-circle,
  &.antecipacao-icon .info-circle {
    color: #72b118;
  }
}

.div-pergunta-selecionada .info-circle.svg-inline--fa {
  width: 21px !important;
  height: 21px !important;
  padding: 0;
}
.mensagem-impressao {
  display: none;
}
@media only print {
  .info-circle{
    color: var(--preto) !important;
  }
  .mensagem-impressao {
    display: block;
    margin: 0 !important;
    padding-left: 10px;
  }
}

</style>
